import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { SectionContainer, SectionContent } from 'builder/components/ProfileSummary/styles'
import {
  SectionHeader,
  SectionHeaderFoldableContainer,
  SectionHint,
  useFoldableSectionHandlers,
} from 'builder/components/Section'
import SectionTitle from 'builder/components/SectionTitle'
import { SectionNames } from 'builder/modules/resumeEditor'
import { getLanguageSection } from '../ExpandableSections'
import { ExpandableSectionWrapper } from '../../ExpandableSectionWrapper'
import { useShokumuTranslations } from '../../useShokumuTranslations'

export const LanguageSkills = (): JSX.Element => {
  const resume = useTypedSelector(state => state.resumeEditor.resume)
  const { i18n } = useShokumuTranslations()
  const title = i18n('languages.title')
  const hint = i18n('languages.hint')
  const { isOpened, handleToggle } = useFoldableSectionHandlers(SectionNames.languages)

  return (
    <SectionContainer>
      <SectionHeader isOpened={isOpened} onClick={handleToggle}>
        <SectionTitle title={title} isOpened={isOpened} />
        <SectionHeaderFoldableContainer isOpened={isOpened}>
          <SectionHint>{hint}</SectionHint>
        </SectionHeaderFoldableContainer>
      </SectionHeader>

      <SectionContent>
        <ExpandableSectionWrapper sections={getLanguageSection(resume)} isOpened={isOpened} />
      </SectionContent>
    </SectionContainer>
  )
}
